import { VODCSSModules } from 'shared/utils/wix-connect';
import { LinkButton } from 'shared/components/button/button';

import styles from './account-info.styl';


@VODCSSModules(styles)
export default class AccountInfo extends React.Component {
  static propTypes = {
    userEmail: React.PropTypes.string,
    logoutLabel: React.PropTypes.string,
    children: React.PropTypes.any,

    onLogoutClick: React.PropTypes.func,
  };

  get content() {
    const { children } = this.props;
    return children ? <div>{children}</div> : null;
  }

  render() {
    const { userEmail, logoutLabel, onLogoutClick } = this.props;
    const { content } = this;

    return (
      <div styleName="container">
        <div styleName="user-email"
             className="qa-account-button-user-email">
          {userEmail}
        </div>

        {content}

        <div styleName="logout-wrapper">
          <LinkButton styleName="logout"
                      data-hook="accountInfoLogoutButton"
                      className="qa-account-button-user-logout"
                      onClick={onLogoutClick}>
            {logoutLabel}
          </LinkButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button/account-info/account-info.js